/**
 * Created by Administrator on 2016/12/26.
 */
export const LOADING = 'LOADING';   // 设置是否显示载入界面
export const NET_ERROR = 'NET_ERROR';   // 设置网络是否错误
export const RECOVERY_TO_VUEX_UNIONLOGIN = 'RECOVERY_TO_VUEX_UNIONLOGIN';



// WEBPACK FOOTER //
// ./src/vuex/mutationsType.js